export const navigationConfig = [
  {
    id: 'simulador-carteira',
    path: '/',
    icon: 'fa-wallet',
    label: 'Simulador Carteira',
    breadcrumb: [{ label: 'Simulador Carteira' }]
  },
  {
    id: 'simulador-flex',
    path: '/simulador-flex',
    icon: 'fa-file-invoice-dollar',
    label: 'Simulador Flex',
    breadcrumb: [{ label: 'Simulador Flex' }]
  }
];

export const getNavigationByPath = (pathname) => {
  return navigationConfig.find(nav => nav.path === pathname);
};

export const getNavigationById = (id) => {
  return navigationConfig.find(nav => nav.id === id);
};
